import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Hinjewaditomumbaicabs() {



  const cardData =
  {
    keyword: ' Hinjewadi to Mumbai Cab',
    heading: 'Sai Trupti Cabs: Hinjewadi to Mumbai Cab',
    headingDescription: 'Sai Trupti Cabs provides dependable and comfortable Hinjewadi to Mumbai cab services, offering a smooth and hassle-free travel experience for business professionals, families, and frequent travelers. Our fleet of air-conditioned Sedans, SUVs, and Luxury cars is well-maintained to ensure comfort, cleanliness, and safety throughout the journey. Whether you’re heading to Mumbai city, Navi Mumbai, or Mumbai Airport, our trained and background-verified chauffeurs guarantee punctual pickups, courteous service, and safe driving. With transparent pricing, flexible booking options, and 24×7 customer assistance, Sai Trupti Cabs makes intercity travel easy and affordable. Enjoy a relaxing and reliable trip from Hinjewadi to Mumbai with Sai Trupti Cabs — your trusted travel companion for outstation rides.',

    top: 'Top Places to Visit in Mumbai with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India stands as Mumbai’s most iconic landmark, overlooking the Arabian Sea in majestic grandeur. Built in 1924 to commemorate King George V’s visit, it blends Indo-Saracenic architecture with colonial elegance. Tourists flock here to enjoy ferry rides to Elephanta Island and admire the sun setting behind the monument. Surrounded by historic hotels and lively street vendors, it is the perfect starting point for exploring South Mumbai’s heritage charm."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, famously known as the Queen’s Necklace, is a 3.6 km boulevard curving gracefully along the Arabian Sea. At night, its glittering streetlights resemble a necklace of pearls, enchanting both locals and travelers. The promenade is perfect for evening strolls, jogs, or simply sitting by the sea breeze. Watching the sunset here with the skyline of Mumbai shimmering in the background offers one of the most serene moments in the bustling metropolis."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
    "description": "A UNESCO World Heritage Site, Chhatrapati Shivaji Maharaj Terminus is a masterpiece of Victorian Gothic architecture fused with Indian artistry. Built in 1887, this grand railway station pulsates with Mumbai’s heartbeat as thousands commute daily. The ornate domes, pointed arches, and stained glass windows narrate stories of the city’s colonial past. It remains not just a transport hub but an architectural marvel symbolizing Mumbai’s vibrant spirit."
  },
  {
    "title": "Elephanta Caves",
    "description": "Situated on Elephanta Island, about 10 km from Mumbai’s shore, the Elephanta Caves are a UNESCO-listed heritage site dating back to the 5th century. These rock-cut temples are dedicated to Lord Shiva and feature magnificent sculptures, including the colossal Trimurti idol. Accessible by ferry from the Gateway of India, the island offers a mix of history, spirituality, and scenic charm. Visitors are captivated by its ancient artistry and tranquil surroundings."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most beloved seaside destinations, stretching over six kilometers along the Arabian coast. Locals and tourists gather here to relish iconic street foods like pav bhaji, bhel puri, and gola. The evenings come alive with laughter, vendors, and the sound of crashing waves. Watching planes land nearby at sunset makes this beach a truly cinematic Mumbai experience. It’s where relaxation meets the vibrant pulse of city life."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah stands gracefully on a tiny islet off Worli, connected to the mainland by a narrow causeway. Built in the 15th century, it houses the tomb of the revered Sufi saint Pir Haji Ali Shah Bukhari. The white marble structure surrounded by the sea exudes spiritual peace and architectural beauty. At high tide, the path gets submerged, making the shrine appear to float on water—a breathtaking symbol of faith amidst Mumbai’s urban energy."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Spread across 100 square kilometers, Sanjay Gandhi National Park is a lush green oasis within the city limits of Mumbai. It offers nature trails, waterfalls, boating, and even a mini zoo for families. The ancient Kanheri Caves nestled inside the park showcase Buddhist rock-cut architecture dating back over 2,000 years. A favorite weekend escape for Mumbaikars, the park perfectly balances nature, history, and adventure in one breathtaking expanse."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "The Shree Siddhivinayak Temple in Prabhadevi is one of Mumbai’s most revered spiritual landmarks dedicated to Lord Ganesha. Built in 1801, it attracts devotees from across India, including film stars and politicians. The temple’s golden dome and intricately carved idol radiate divine grace. Devotees believe that praying here fulfills wishes, making it a hub of faith, devotion, and cultural unity in the heart of Mumbai."
  },
  {
    "title": "Colaba Causeway Market",
    "description": "Colaba Causeway is Mumbai’s vibrant shopping street known for its eclectic mix of fashion, handicrafts, antiques, and cafés. Whether you’re hunting for souvenirs, jewelry, or bohemian clothing, this market offers it all at irresistible prices. The charming colonial architecture adds to its nostalgic charm. With nearby attractions like the Gateway of India and Leopold Café, Colaba represents the city’s cosmopolitan soul and artistic flair."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "description": "The Bandra-Worli Sea Link is a marvel of modern engineering connecting South Mumbai with the western suburbs. Its cable-stayed structure gleams over the Arabian Sea, especially when illuminated at night. Driving across this eight-lane bridge offers panoramic skyline views and a glimpse of Mumbai’s futuristic spirit. The Sea Link is not just a roadway but a symbol of progress, resilience, and Mumbai’s forward-moving ambition."
  }
],



"services": [
  {
    "name": "Hinjewadi to Mumbai Cab",
    "description": "Hinjewadi to Mumbai Cab provides reliable intercity travel for passengers commuting between Hinjewadi and Mumbai. Featuring a fleet of well-maintained vehicles and professional drivers, this service ensures a safe, comfortable, and timely journey. Ideal for business trips, family outings, or airport transfers, it offers transparent pricing, online booking, and 24/7 customer support for a seamless travel experience along the Pune-Mumbai route."
  },
  {
    "name": "Hinjewadi to Mumbai Taxi",
    "description": "Hinjewadi to Mumbai Taxi offers convenient and secure taxi services for travelers heading to Mumbai. With trained drivers, clean and comfortable vehicles, and door-to-door service, this taxi option ensures a hassle-free and smooth ride. Online booking, fare transparency, and multiple payment options make it suitable for tourists, business travelers, and families seeking dependable intercity travel."
  },
  {
    "name": "Hinjewadi to Mumbai Car Rental",
    "description": "Hinjewadi to Mumbai Car Rental provides a range of vehicles for intercity trips, from hatchbacks to luxury cars. Customers can choose between self-drive or chauffeur-driven options, enjoying maximum flexibility and convenience. With professional drivers, well-maintained vehicles, transparent pricing, and easy online booking, this service ensures safe, comfortable, and stress-free travel between Hinjewadi and Mumbai."
  },
  {
    "name": "Hinjewadi to Mumbai Innova Cab",
    "description": "Hinjewadi to Mumbai Innova Cab offers spacious and reliable Toyota Innovas ideal for families and groups. The service guarantees air-conditioned comfort, ample seating, and smooth rides. Experienced drivers ensure safe and timely intercity travel, while online booking, 24/7 customer support, and transparent fares make planning trips effortless and convenient."
  },
  {
    "name": "Hinjewadi to Mumbai Ertiga Cab",
    "description": "Hinjewadi to Mumbai Ertiga Cab provides comfortable Maruti Ertiga vehicles suitable for medium-sized groups traveling to Mumbai. With professional drivers, clean interiors, and air-conditioned comfort, this service ensures a safe and enjoyable ride. Online booking, fare transparency, and 24/7 support further enhance convenience and reliability for business or leisure travel."
  },
  {
    "name": "Hinjewadi to Mumbai One Way Taxi",
    "description": "Hinjewadi to Mumbai One Way Taxi offers economical and convenient single-trip services for passengers traveling to Mumbai. Ideal for airport transfers, business trips, or personal journeys, the service features professional drivers, air-conditioned vehicles, and online booking. Transparent pricing ensures a cost-effective yet comfortable and safe intercity travel experience."
  },
  {
    "name": "Hinjewadi to Mumbai Drop Cab",
    "description": "Hinjewadi to Mumbai Drop Cab specializes in one-way intercity trips, ensuring timely and reliable drop services. The service offers a variety of vehicles including sedans, SUVs, and hatchbacks. Experienced drivers and comfortable interiors guarantee a smooth journey, while online booking and 24/7 customer support provide convenience and peace of mind for all travelers."
  },
  {
    "name": "Hinjewadi to Mumbai Airport Taxi",
    "description": "Hinjewadi to Mumbai Airport Taxi provides dedicated airport transfer services for passengers traveling to or from Mumbai airports. Punctual pickups, professional drivers, and air-conditioned vehicles ensure stress-free airport commutes. Online booking, fare transparency, and real-time ride tracking make this service reliable for both domestic and international travelers."
  },
  {
    "name": "Hinjewadi to Mumbai Outstation Cab",
    "description": "Hinjewadi to Mumbai Outstation Cab offers intercity travel solutions designed for long-distance trips. With a fleet of well-maintained vehicles and experienced drivers familiar with the route, passengers can enjoy a safe, comfortable, and timely journey. Online booking, fare transparency, and 24/7 support enhance convenience for families, business travelers, and tourists alike."
  },
  {
    "name": "Affordable Hinjewadi to Mumbai Taxi",
    "description": "Affordable Hinjewadi to Mumbai Taxi provides budget-friendly intercity travel without compromising on comfort or reliability. Ideal for students, families, and frequent travelers, this service ensures clean vehicles, professional drivers, and transparent pricing. Online booking and 24/7 assistance further enhance convenience, making it a dependable choice for cost-effective intercity travel."
  },
  {
    "name": "Hinjewadi to Mumbai Luxury Cab",
    "description": "Hinjewadi to Mumbai Luxury Cab caters to travelers seeking a premium travel experience. Featuring high-end vehicles such as BMW, Mercedes, and Audi, the service offers luxurious interiors, professional chauffeurs, and top-tier comfort. Online booking, fare transparency, and 24/7 support ensure a safe, elegant, and stress-free journey for business executives, VIP clients, or special occasions."
  },
  {
    "name": "Hinjewadi to Mumbai Online Booking",
    "description": "Hinjewadi to Mumbai Online Booking allows customers to reserve cabs digitally with ease. Users can select vehicle types, schedule pickups, and receive instant confirmations. Multiple payment options, fare transparency, and online cancellations make the process seamless. Real-time tracking, driver details, and 24/7 support ensure a convenient, reliable, and safe intercity travel experience."
  },
  {
    "name": "Hinjewadi to Mumbai Cab near Me",
    "description": "Hinjewadi to Mumbai Cab near Me provides quick access to nearby cabs for immediate or scheduled travel to Mumbai. Featuring well-maintained vehicles, professional drivers, and fast booking options, this service ensures a smooth and comfortable journey. Transparent fares, air-conditioned interiors, and reliable service make it ideal for airport transfers, business trips, or urgent travel needs."
  },
  {
    "name": "Hinjewadi to Mumbai Sedan Hire",
    "description": "Hinjewadi to Mumbai Sedan Hire offers mid-sized sedans for comfortable intercity travel. Ideal for small families, corporate travelers, or solo passengers, the service includes air-conditioned vehicles, ample luggage space, and smooth rides. Professional drivers, online booking, and transparent pricing ensure a reliable, convenient, and stress-free journey between Hinjewadi and Mumbai."
  },
  {
    "name": "Hinjewadi to Mumbai Taxi Fare",
    "description": "Hinjewadi to Mumbai Taxi Fare provides detailed and transparent pricing information for intercity taxi services. Passengers can easily estimate the cost of travel based on vehicle type, distance, and additional services. Combined with online booking and 24/7 customer support, this service ensures travelers can plan their trips effectively while enjoying a comfortable, safe, and economical ride."
  }
],
"tableData": [
  ["Hinjewadi to Mumbai Cab", "Hinjewadi to Mumbai Taxi"],
  ["Hinjewadi to Mumbai Car Rental", "Hinjewadi to Mumbai Innova Cab"],
  ["Hinjewadi to Mumbai Ertiga Cab", "Hinjewadi to Mumbai One Way Taxi"],
  ["Hinjewadi to Mumbai Drop Cab", "Hinjewadi to Mumbai Airport Taxi"],
  ["Hinjewadi to Mumbai Outstation Cab", "Affordable Hinjewadi to Mumbai Taxi"],
  ["Hinjewadi to Mumbai Luxury Cab", "Hinjewadi to Mumbai Online Booking"],
  ["Hinjewadi to Mumbai Cab near Me", "Hinjewadi to Mumbai Sedan Hire"],
  ["Hinjewadi to Mumbai Taxi Fare", ""]
],


"whychoose": [
  {
    "WhyChooseheading": "Hinjewadi to Mumbai Cab Service",
    "WhyChoosedescription": "Sai Trupti Cabs  offers reliable and comfortable cab services from Hinjewadi (Pune) to Mumbai, perfect for business travel, airport transfers, or leisure trips."
  },
  {
    "WhyChooseheading": "Transparent and Competitive Fare",
    "WhyChoosedescription": "We provide clear one‑way fares from Hinjewadi to Mumbai with no hidden charges—what you see is what you pay."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs or premium cars to suit your group size, luggage, and comfort preferences for the Hinjewadi‑to‑Mumbai route."
  },
  {
    "WhyChooseheading": "Experienced & Punctual Drivers",
    "WhyChoosedescription": "Our courteous, professional drivers know the Hinjewadi to Mumbai route well and ensure a safe, smooth and timely journey."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop‑off Locations",
    "WhyChoosedescription": "We facilitate convenient pickups in Hinjewadi (and surrounding Pune suburbs) and drop‑offs across Mumbai — including airports, railway stations and city spots."
  },
  {
    "WhyChooseheading": "Clean, Well‑Maintained Vehicles",
    "WhyChoosedescription": "All our cabs are regularly serviced, sanitized and maintained to provide a comfortable ride over the long Hinjewadi‑to‑Mumbai distance."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to assist with bookings, modifications or travel queries."
  },
  {
    "WhyChooseheading": "Hassle‑Free Booking Process",
    "WhyChoosedescription": "Book your Hinjewadi to Mumbai cab easily via call, WhatsApp or our website — with instant confirmation and prompt dispatch."
  }
]























  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs  offer Hinjewadi to Mumbai cab services?',
    answer: 'Yes, Sai Trupti Cabs  provides reliable and affordable Hinjewadi to Mumbai cab services for one way, round trip, and airport transfers.',
  },
  {
    question: 'How can I book a Hinjewadi to Mumbai cab with Sai Trupti Cabs?',
    answer: 'You can easily book your Hinjewadi to Mumbai cab through our website, mobile app, or by contacting our 24×7 customer support team.',
  },
  {
    question: 'What types of cabs are available from Hinjewadi to Mumbai?',
    answer: 'We offer hatchbacks, sedans, SUVs, tempo travellers, and luxury cars to suit your travel needs, group size, and budget.',
  },
  {
    question: 'Are the drivers experienced for the Hinjewadi to Mumbai route?',
    answer: 'Yes, all our drivers are professional, courteous, and experienced in driving on the Hinjewadi–Mumbai route, ensuring a safe and comfortable journey.',
  },
  {
    question: 'Can I book a Hinjewadi to Mumbai cab for airport transfers?',
    answer: 'Certainly. We provide dedicated Hinjewadi to Mumbai airport cab services with on-time pickup and drop for both domestic and international terminals.',
  },
  {
    question: 'Is the Hinjewadi to Mumbai cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 cab services from Hinjewadi to Mumbai for your convenience and travel flexibility.',
  },
  {
    question: 'What are the Hinjewadi to Mumbai cab fares?',
    answer: 'Our cab fares start from ₹1,800 for hatchbacks, ₹2,100–₹2,800 for sedans, and ₹3,500 onwards for SUVs, depending on vehicle type and travel requirements.',
  },
  {
    question: 'What payment options are accepted for Hinjewadi to Mumbai cab bookings?',
    answer: 'We accept payments via UPI, credit/debit cards, bank transfers, and digital wallets for secure and convenient transactions.',
  },
  {
    question: 'What safety and hygiene protocols are followed for Hinjewadi to Mumbai cabs?',
    answer: 'All vehicles are sanitized before every trip, and our drivers follow strict safety and hygiene protocols to ensure a safe journey.',
  },
  {
    question: 'Is customer support available during the Hinjewadi to Mumbai cab ride?',
    answer: 'Yes, our 24×7 customer support team is available to assist you throughout your Hinjewadi to Mumbai cab journey.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Pradeep Kulkarni',
    feedback: 'I booked a Hinjewadi to Mumbai cab with Sai Trupti Cabs. The driver was punctual and the car was clean and comfortable.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Sneha Deshmukh',
    feedback: 'Sai Trupti Cabs provided excellent service for my Hinjewadi to Mumbai trip. Smooth ride and very professional driver.',
    rating: 5,
  },
];

























































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];

















const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Hinjewadi to Mumbai Cab",
  "image": "https://saitrupticabs.com/assets/images/hinjewadi-to-mumbai-cab.jpg",
  "description": "Book Hinjewadi to Mumbai Cab with Sai Trupti Cabs for a safe, affordable, and comfortable journey. Choose from AC Sedans, SUVs, and Luxury Cars for one-way, round-trip, airport transfers, or outstation travel. Enjoy 24/7 online booking, verified drivers, and transparent fares for a hassle-free ride.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "15678"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2399",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/hinjewadi-to-mumbai-cab"
  }
};


  return (
    <div>
      <Helmet>
  <title>Hinjewadi to Mumbai Cab | Affordable & Reliable | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Book Hinjewadi to Mumbai Cab with Sai Trupti Cabs for a safe, affordable, and comfortable journey. Choose from AC Sedans, SUVs, and Luxury Cars for one-way, round-trip, airport transfers, or outstation travel. Enjoy 24/7 online booking, verified drivers, and transparent fares for a hassle-free ride." 
  />
  <meta 
    name="keywords" 
    content="Hinjewadi to Mumbai Cab, Hinjewadi to Mumbai Taxi, Hinjewadi to Mumbai Car Rental, Hinjewadi to Mumbai Innova Cab, Hinjewadi to Mumbai Ertiga Cab, Hinjewadi to Mumbai One Way Taxi, Hinjewadi to Mumbai Drop Cab, Hinjewadi to Mumbai Airport Taxi, Hinjewadi to Mumbai Outstation Cab, Affordable Hinjewadi to Mumbai Taxi, Hinjewadi to Mumbai Luxury Cab, Hinjewadi to Mumbai Online Booking, Hinjewadi to Mumbai Cab near Me, Hinjewadi to Mumbai Sedan Hire, Hinjewadi to Mumbai Taxi Fare" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/10.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Hinjewaditomumbaicabs;